import { num, fmtDate } from "@/lib/format";

export function shoppingListText(list, unitName) {
  const groups = {};
  list.items.forEach((i) => { const k = i.category_name || "Outros"; (groups[k] = groups[k] || []).push(i); });
  const lines = [`🛒 *Lista de compras: ${list.name}*`];
  lines.push(`🏪 ${unitName || ""} · 📅 ${fmtDate(new Date().toISOString())}`.trim());
  if (list.note) lines.push(`📝 ${list.note}`);
  Object.keys(groups).sort().forEach((g) => {
    lines.push("", `*${g}*`);
    groups[g].forEach((i) => lines.push(`• ${i.product_name} — ${num(i.qty)} ${i.unit}`));
  });
  lines.push("", `📦 Total: ${list.items.length} ite${list.items.length === 1 ? "m" : "ns"}`);
  return lines.join("\n");
}

export const whatsappUrl = (text) => `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;

export function sendToWhatsApp(text) {
  window.open(whatsappUrl(text), "_blank", "noopener");
}

export async function nativeShare(text, title) {
  if (!navigator.share) return false;
  try {
    await navigator.share({ title, text });
    return true;
  } catch {
    return true;
  }
}
